export default __webpack_public_path__ + "static/media/silver_glass.66297268.png";